module.exports = __webpack_public_path__ + "assets/e3ef17f775489257bbc83510c0e8169a.png";